export default __webpack_public_path__ + "static/media/char-yoda.97991bfa.jpg";